import { render } from "./UpgradeContent.vue?vue&type=template&id=0c235b52"
import script from "./UpgradeContent.vue?vue&type=script&lang=js"
export * from "./UpgradeContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__